const localized = (event, localizationData) => {
  const localize = (key) => localizationData[key] || key;

  return {
    ...event,
    title: localize(event.title),
    description: event.description ? localize(event.description) : undefined,
    variants: event.variants?.map((variant) => ({
      ...variant,
      day: variant.day
        ? {
          ...variant.day,
          description: Array.isArray(variant.day.description)
            ? variant.day.description.map(localize)
            : localize(variant.day.description),
        }
        : undefined,
      night: variant.night
        ? {
          ...variant.night,
          description: Array.isArray(variant.night.description)
            ? variant.night.description.map(localize)
            : localize(variant.night.description),
        }
        : undefined,
    })),
    buttons: event.buttons?.map((button) => ({
      ...button,
      title: localize(button.title),
      message: localize(button.message),
      combat: !button.combat ? undefined : {
        ...button.combat,
        description: Array.isArray(button.combat.description)
          ? button.combat.description.map(localize)
          : localize(button.combat.description),
        victory: localize(button.combat.victory),
        defeat: localize(button.combat.defeat),
      },
    })),
  };
};

export default localized;
